import React from 'react'
import { ActivityObjectType } from './types'
import type { Activity } from './types'
import { ExtensionActivityDetail } from './ExtensionActivityDetail'
import { AgentActivityDetails } from './AgentActivityDetails'
import { MessageActivityDetails } from './MessageActivityDetails'
import { ChecklistActivityDetails } from './ChecklistActivityDetails'
import { ClinicalNoteActivityDetail } from './ClinicalNoteActivityDetail'
import { FormActivityDetails } from './FormActivityDetails/FormActivityDetails'
import { CalculationActivityDetails } from './CalculationActivityDetails/CalculationActivityDetails'
import { ApiCallActivityDetails } from './ApiCallActivityDetails/ApiCallActivityDetails'
import { EmrActivityDetails } from './EmrActivityDetails/EmrActivityDetails'
import { DecisionActivityDetails } from './DecisionActivityDetails'
import { TimerActivityDetails } from './TimerActivityDetails/TimerActivityDetails'

interface ActivityDetailsRendererProps {
  activity: Activity
  onClose: () => void
}

export const ActivityDetailsRenderer = ({ activity, onClose }: ActivityDetailsRendererProps): JSX.Element | null => {
  const { type } = activity.object

  switch (type) {
    case ActivityObjectType.PluginAction:
      return <ExtensionActivityDetail activity={activity} onClose={onClose} />

    case ActivityObjectType.Agent:
      return <AgentActivityDetails activity={activity} />

    case ActivityObjectType.Message:
      return <MessageActivityDetails activity={activity} />

    case ActivityObjectType.Checklist:
      return <ChecklistActivityDetails activity={activity} onClose={onClose} />

    case ActivityObjectType.ClinicalNote:
      return <ClinicalNoteActivityDetail activity={activity} />

    case ActivityObjectType.Form:
      return <FormActivityDetails activity={activity} onClose={onClose} />

    case ActivityObjectType.Calculation:
      return <CalculationActivityDetails activity={activity} />

    case ActivityObjectType.ApiCall:
      return <ApiCallActivityDetails activity={activity} />

    case ActivityObjectType.EmrReport:
      return <EmrActivityDetails activity={activity} />

    case ActivityObjectType.Decision:
      return <DecisionActivityDetails activity={activity} />

    case ActivityObjectType.Timer:
      return <TimerActivityDetails activity={activity} />

    default:
      console.warn(`No activity details component found for activity type: ${type}`)
      return null
  }
}
